import { cx } from '@linaria/core';
import { usePM2DisplayContext } from '@pm2/store';
import { breakpoints } from '@ui/css';
import { Button } from '@ui/kit';
import { SpeechIcon } from '@ui/kit/icons';
import { speechButtonSelectors } from '@ui/kit/selectors';
import { useMatchBreakpoint } from '@utils/react';
import { toggler } from './_toggler.styles.js';
import { jsx } from 'react/jsx-runtime';

function AudioPlayerToggler(props) {
  const isMobile = useMatchBreakpoint(breakpoints.mobile);
  const {
    inGrid
  } = usePM2DisplayContext();
  const showLabel = !isMobile && !inGrid;
  return /*#__PURE__*/jsx(Button, {
    theme: "primary",
    className: cx(toggler, speechButtonSelectors.attachedAudioButton.className),
    onClick: props.onToggle,
    icon: /*#__PURE__*/jsx(SpeechIcon, {}),
    tooltip: {
      ariaType: "label",
      disabled: showLabel,
      body: props.toggled ? "Stop afspilning" : "Læs op"
    },
    children: showLabel && (props.toggled ? "Stop afspilning" : "Læs op")
  });
}

export { AudioPlayerToggler };
//# sourceMappingURL=_toggler.js.map
